import React, { useState } from 'react';
import { Modal, Form, message } from 'antd';
import SupplierForm from './SupplierForm';
import apiClient from '../services/api';

interface SupplierModalProps {
  visible: boolean;
  onCancel: () => void;
  onSuccess: (supplier: any) => void;
}

const SupplierModal: React.FC<SupplierModalProps> = ({ visible, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleFinish = async (values: any) => {
    setLoading(true);
    try {
      const supplier = await apiClient.createSupplier(values);
      message.success('Tạo nhà cung cấp thành công!');
      onSuccess(supplier);
      form.resetFields();
    } catch (error) {
      message.error('Tạo nhà cung cấp thất bại!');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Tạo nhà cung cấp mới"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={600}
    >
      <SupplierForm
        form={form}
        onFinish={handleFinish}
        loading={loading}
        submitText="Tạo mới"
      />
    </Modal>
  );
};

export default SupplierModal; 